import React, {useEffect} from "react";
import {TabsProps} from "antd";
import "./Discipline.scss";
import {useAppSelector} from "redux/hooks";

import {tabKeys} from "types/enums/tab-keys";
import {Tabs} from "components/common";
import ListDiscipline from "./Tab/ListDiscipline";

// const items: TabsProps["items"] = [
//   {
//     key: tabKeys.SURGERY.PATIENT_LIST,
//     label: `Kỷ luật`,
//     children: <ListDiscipline />,
//   },
// ];

const Discipline: React.FC = () => {
  document.title = "Kỷ luật";
  const activeTab = useAppSelector(state => state.common.activeTab);
  useEffect(() => {}, []);
  return (
    <div className=" recruitment page">
      <div className="main">
        <ListDiscipline />
      </div>
    </div>
  );
};
export default Discipline;
